import { render, staticRenderFns } from "./HolidaysTable.vue?vue&type=template&id=48f4ea0a"
import script from "./HolidaysTable.vue?vue&type=script&lang=js"
export * from "./HolidaysTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports